import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateFormateService } from 'src/app/services/date-formate.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { MakerCheckerConfig } from '../../shared/models/maker-checker-config';
import * as moment from 'moment';

@Component({
  selector: 'app-maker-cheacker-configuration',
  templateUrl: './maker-cheacker-configuration.component.html',
  styleUrls: ['./maker-cheacker-configuration.component.scss']
})
export class MakerCheackerConfigurationComponent implements OnInit {
  status : boolean ;
  _form: FormGroup;
  submitted = false;
  configList :any = [];
  
  @Input() model: MakerCheckerConfig = new MakerCheckerConfig();
  constructor(
    private modalService: NgbModal,
    public apiService: ApiService,
    public apiConfig: ApiConfiguration,
    public toast: ToastClientService,
    private router: Router,
    private formBuilder: FormBuilder,
    public alertService: AlertService,
    private formateDate: DateFormateService,
  ) { 
    this._form = this.formBuilder.group({
      start_date: ["", Validators.required],
      end_date: ["", Validators.required],
      limit_points : ["", Validators.required],
    });
  }

  ngOnInit() {
    this.getMakerCheckerConfigList()
  }
  showBrandCategoryModal(targetModal){
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static'
    });
  }
  openModal(makerChecker){
    this.showBrandCategoryModal(makerChecker)
  }

  changeStatus(item){
    console.log(item.target.checked)
  }

  get f() {
    return this._form.controls;
  }

  onSubmit(data){
    this.submitted = true;
    if (this._form.invalid) {
      return;
    }else{
      // this.model.start_date = this.formateDate.formateDate(this.model.start_date);
      // this.model.end_date = this.formateDate.formateDate(this.model.end_date);
      let payload = {
        start_date: moment(data.start_date).format("YYYY-MM-DD"),
        end_date: moment(data.end_date).format("YYYY-MM-DD"),
        limit_points: data.limit_points,
      }
        this.apiService.post(this.apiConfig.addMakerCheckerConfig, payload)
        .subscribe((res: any)=>{
          this.toast.Success(res.body.data.message);
          this.modalService.dismissAll();
          this.getMakerCheckerConfigList()
        },err => {
          this.toast.Error(err);
        });
    }

  }

  getMakerCheckerConfigList(){
    this.apiService.get(this.apiConfig.listMakerCheckerConfig)
    .subscribe((res:any) => {
      this.configList = res.data.list

    })
  }

  toggleStatus(status, configid){

    let payload = {
      status: status,
      id: configid,
    }

    this.apiService.post(this.apiConfig.toggleConfigStatus, payload)
    .subscribe((res: any)=>{
      this.toast.Success(res.body.data.message);
      this.getMakerCheckerConfigList()
      console.log(res);
    },err => {
      this.toast.Error(err);
    });

  }

}
